// TODO RCH : maybe we should put all API calls here to make it easier
import I18n from "../utils/I18n";
import { Request } from "sp-react-commons";
import AppConfig from "AppConfig";
import getIdentityKey from "../utils/IdentityConfig";

let LoginApi = {
    loginRedirect(referrer, lang = "de") {
        return `/oauth/login?lang=${lang}&referrer=${encodeURIComponent(referrer)}`;
    }
};

let PaywallApi = {
    apiBaseUrl: `/api/${I18n.lang()}/paywall`,
    baseUrl: `/${I18n.lang()}/paywall`,

    ///TODO HPW
    subscribeToAnnouncement: function (email, announcementId, utmParams) {
        return Request.post(`${this.baseUrl}/subscribe/${email}/${announcementId}?${utmParams}`)
    }
};

let VoucherApi = {
    getRedeemLink: function (code) {
        return Request.get(`/${I18n.lang()}/voucher/redeem/${code}/link`)
    }
};

let TrackingApi = {
    baseUrl: `/trk/api`,

    // Always use Tracking.track() instead of this
    track: function (action, data) {
        let url = `/api/trk?action=${action}`;
        let dataTxt = JSON.stringify(data);


        if(navigator.sendBeacon) {
            navigator.sendBeacon(url, dataTxt);
        } else {
            jQuery.ajax({
                type: "POST",
                url: url,
                contentType: "text/plain",
                data: dataTxt
            });
        }
    }
};

let TrafficApi = {
    baseUrl: `/api/v302/sites/${I18n.lang()}/services/traffic`,

    getParkings: function () {
        return Request.get(`${this.baseUrl}/parkings`);
    }
};

let LatinaApi = {
    baseUrl: `/api/v1/sites/pt/latina`,
    playerUrl: '/pt/latina/player',

    getPlaylist: function() {
        return Request.get(`${this.baseUrl}/playlist`);
    },

    playlistUpdates: function() {
        return new WebSocket(`${AppConfig.latinaWebsocketHost}${this.baseUrl}/playlistUpdates`);
    }
};

let AnnouncementApi = {
    baseUrl: `/api/v304/${I18n.lang()}/services`,

    getAnnouncements: function (announcementType) {
        return Request.get(`${this.baseUrl}/announcements/${announcementType}`);
    },

    getAnnouncement: function (announcementId) {
        return Request.get(`${this.baseUrl}/announcement/${announcementId}`);
    }
};

let SportResultsApi = {
    baseUrl: `/api/v302/sites/${I18n.lang()}/services/sports`,

    getSportsWithLeaguesAndDivisions: function() {
        return Request.get(this.baseUrl);
    },

    getDayMatches: function(divisionId, matchDay) {
        return Request.get(`${this.baseUrl}/divisions/${divisionId}/matchdays/${matchDay}`)
    },

    getRanking: function(divisionId) {
        return Request.get(`${this.baseUrl}/divisions/${divisionId}/ranking`)
    }
};

let HomeApi = {
    baseUrl: `/api/${I18n.lang()}/home`,

    getUpdates: function (version) {
        return Request.get(`${this.baseUrl}/updates?&version=${version}`)
    }
};

let PnsNotificationsApi = {
    baseUrl: `/api/web/500`,

    subscribeToPnsNotifications: function(token, data) {
        return Request.post(`${this.baseUrl}/device_tokens/${token}`, data)
    },

    getPnsToken: function (token, applicationId) {
        return Request.get(`${this.baseUrl}/token/${token}/${applicationId}`)
    }
};

let ChartApi = {
    baseUrl: `${getIdentityKey("webHost")}/api/v1/${I18n.lang()}/articles`,

    getChart: function (contentId, chartId) {
        return Request.get(`${this.baseUrl}/${contentId}/charts/${chartId}`);
    },

    getMap: function (mapType) {
        return Request.get(`${getIdentityKey("webHost")}/assets/javascripts/maps/${mapType}.json`)
    }
};

export { LoginApi, PaywallApi, LatinaApi, TrafficApi, AnnouncementApi, SportResultsApi, TrackingApi, HomeApi, ChartApi, PnsNotificationsApi, VoucherApi }



// WEBPACK FOOTER //
// ./js/api/Api.js